import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { GetCategoryServicesDataTypes } from "../../../../Schema/getCategoryServices.types";

export type GetCategoryServicesLoadAction = {
  type: string;
  payload: { id: number | string };
};

export type CategoryExpertsTypes = {
  avatar: string | null;
  expertise: string;
  full_name: string;
  id: number;
};

export type GetCategoryServicesData = {
  data: {
    services: GetCategoryServicesDataTypes[];
    category_title: string;
    category_desc: string;
    category_info: string;
    category_experts: CategoryExpertsTypes[];
  };
};

const GetCategoryServices = new ReduxFetchState<
  GetCategoryServicesData,
  { id: number | string },
  any
>("getCategoryServices");

export function* watchGetCategoryServices(action: GetCategoryServicesLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const { id } = action.payload;
    const data: GetCategoryServicesData = yield axios({
      url: `/api/v1/ai/category/${id}/services`,
      method: "GET",
      headers: { lang },
    });

    yield put(
      GetCategoryServices.actions.loadSuccess({
        data: data.data,
      }),
    );
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(GetCategoryServices.actions.loadFailure(e.message));
  }
}

export function* getCategoryServicesSagas() {
  yield takeEvery(GetCategoryServices.actionTypes.load, watchGetCategoryServices);
}

export function useGetCategoryServices() {
  const { loading, data, ...getCategoryServicesState } = useAppSelector(
    (state) => state.getCategoryServices,
  );
  const dispatch = useAppDispatch();

  const dispatchGetCategoryServices = useCallback(
    (data: { id: number | string }) => {
      dispatch(GetCategoryServices.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...getCategoryServicesState,
    dispatchGetCategoryServices,
    getCategoryServicesLoading: loading,
    getCategoryServicesData: data,
  };
}

export const {
  actionTypes: getCategoryServicesActionsTypes,
  actions: getCategoryServicesActions,
  reducer: getCategoryServicesReducer,
} = GetCategoryServices;
